export default {
	newPair: state => state.newPair
};
